var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLevel4Illustration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 794 794",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M411.785 432.26H266.963v61.587h101.638L165.268 698.196l43.523 43.552 202.994-204.011v100.904h61.559V432.26h-61.559z",
    fill: "#F26445"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M144.466 470.081H59.904v35.959h59.329L.49 625.403l25.431 25.431 118.545-119.138v58.934h35.959V470.081h-35.959z",
    fill: "#F0BE8C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M620.456 52.463l41.18 126.815H795l-107.876 78.381 41.18 126.815-107.848-78.381-107.876 78.381 41.18-126.815-107.848-78.381h133.335l41.209-126.815z",
    fill: "#48B7A1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M308.313 213.373l16.116 49.592h52.132l-42.168 30.652 16.116 49.592-42.196-30.653-42.169 30.653 16.089-49.592-42.169-30.652h52.132l16.117-49.592z",
    fill: "#F26445"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLevel4Illustration);
export default __webpack_public_path__ + "static/media/level-4-illustration.19d17507137483a0d7f4526fef454e9e.svg";
export { ForwardRef as ReactComponent };